//CRN_20251003 - Add to host template
//             - <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

import { Component, OnInit, TemplateRef } from '@angular/core';
import { ConfigSystemParams } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toast-service';

@Component({
  selector: 'app-toasts',
  standalone: true,
  template: `
    @for(toast of toastService.toasts;track $index){
      <ngb-toast [class]="toast.classname" [autohide]="autoHideToast" [delay]="toast.delay || 2000" (hidden)="toastService.remove(toast)">
      @if(!autoHideToast) {
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" (click)="closeToast(toast)"></button>
      }
        <div style="text-align:center">
          {{ toast.textOrTpl }}
        </div>
      </ngb-toast>
    }
  `,
  host: { 'class': 'toast-container position-fixed bottom-0 end-0 p-3', 'style': 'z-index: 1200' },
  imports:[NgbToastModule]
})
export class ToastsContainer implements OnInit {

  public autoHideToast: boolean=true;

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    public  toastService       : ToastService
  ) { }

  public ngOnInit(): void {
    try {
      this.toastService.toastAdded.subscribe(event => this.toastAdded(event));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeToast(toast: any) {
    try {
      this.toastService.remove(toast);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toastAdded(e: any) {
    try {
      this.autoHideToast=this.configSystemService.getValueAsBoolean(ConfigSystemParams.AutoHideToast, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
